import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored customer object.
 */
export const storedCustomerSchema: SchemaDefinition = {
	Name: 'stored-customer-number',
	Properties: {
		Name: { Type: 'string' },
		Terminal: { Type: 'string' }
	}
}